import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var style = require('./ParallaxTemplate.css');
var BACKGROUND_MAX_HEIGHT = 740;
export var ParallaxTemplate = /*#__PURE__*/function (_React$Component) {
  function ParallaxTemplate(props) {
    var _this;
    _classCallCheck(this, ParallaxTemplate);
    _this = _callSuper(this, ParallaxTemplate, [props]);
    _defineProperty(_this, "container", null);
    _defineProperty(_this, "animatedBg", null);
    _defineProperty(_this, "topPosition", void 0);
    _defineProperty(_this, "bottomPosition", void 0);
    _defineProperty(_this, "containerHeight", void 0);
    _defineProperty(_this, "scrollHandler", void 0);
    _defineProperty(_this, "resizeHandler", void 0);
    _this.state = {
      bgPosition: 0
    };
    return _this;
  }
  _inherits(ParallaxTemplate, _React$Component);
  return _createClass(ParallaxTemplate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.container) {
        var shouldChange = false;
        this.containerHeight = this.container.offsetHeight;
        var scrollHandler = function scrollHandler() {
          if (!shouldChange) {
            return;
          }
          shouldChange = false;
          if (window.scrollY > _this2.topPosition && window.scrollY < _this2.bottomPosition && _this2.animatedBg) {
            var bgOffset = (window.scrollY - _this2.topPosition) / (window.innerHeight + BACKGROUND_MAX_HEIGHT);
            var translate = bgOffset * (_this2.containerHeight - BACKGROUND_MAX_HEIGHT);
            _this2.animatedBg.style.transform = "translateY(".concat(Math.round(translate), "px)");
          }
        };
        var img = new Image();
        this.scrollHandler = function () {
          shouldChange = true;
          requestAnimationFrame(scrollHandler);
        };
        this.resizeHandler = function () {
          _this2.getParams();
          requestAnimationFrame(scrollHandler);
        };
        img.onload = function () {
          _this2.getParams();
          _this2.setState({
            bgPosition: window.innerHeight - BACKGROUND_MAX_HEIGHT
          });
          window.addEventListener('scroll', _this2.scrollHandler);
          window.addEventListener('resize', _this2.resizeHandler);
        };
        img.src = this.props.backgroundImage;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.scrollHandler);
      window.removeEventListener('resize', this.resizeHandler);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        backgroundImage = _this$props.backgroundImage,
        textImage = _this$props.textImage,
        footnote = _this$props.footnote,
        url = _this$props.url;
      return /*#__PURE__*/_jsx("a", {
        "data-name": "ParallaxTemplate",
        href: url,
        target: "_blank",
        rel: "noreferrer noopener nofollow",
        children: /*#__PURE__*/_jsxs("div", {
          className: style['container'],
          ref: function ref(container) {
            _this3.container = container;
          },
          children: [/*#__PURE__*/_jsx("div", {
            ref: function ref(animatedBg) {
              return _this3.animatedBg = animatedBg;
            },
            className: style['background'],
            style: {
              backgroundImage: "url(".concat(backgroundImage, ")")
            }
          }), /*#__PURE__*/_jsx("div", {
            className: style['image'],
            style: {
              backgroundImage: "url(".concat(textImage, ")")
            }
          }), footnote && /*#__PURE__*/_jsx("div", {
            className: style['footnote'],
            children: footnote
          })]
        })
      });
    }
  }, {
    key: "getParams",
    value: function getParams() {
      if (this.container) {
        this.topPosition = this.container.offsetTop - window.innerHeight;
        this.bottomPosition = this.topPosition + this.container.offsetHeight + window.innerHeight;
      }
    }
  }]);
}(React.Component);